import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export default function InhuurBundelRespond() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [acties, setActies] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    fetch(`/api/inhuur/public/bundle/${token}`)
      .then(r => r.ok ? r.json() : r.json().then(j => Promise.reject(j)))
      .then(d => {
        setData(d);
        const init = {};
        d.bestellingen.forEach(b => {
          init[b.id] = { actie: b.response_actie || 'overslaan', reden: b.response_reden || '' };
        });
        setActies(init);
        setLoading(false);
      })
      .catch(e => { setError(e.error || 'Fout bij laden'); setLoading(false); });
  }, [token]);

  function setActie(id, actie) { setActies(p => ({ ...p, [id]: { ...p[id], actie } })); }
  function setReden(id, reden) { setActies(p => ({ ...p, [id]: { ...p[id], reden } })); }

  async function submit() {
    setSubmitting(true);
    try {
      const payload = {
        acties: data.bestellingen
          .filter(b => acties[b.id] && acties[b.id].actie !== 'overslaan' && !b.response_actie)
          .map(b => ({ id: b.id, actie: acties[b.id].actie, reden: acties[b.id].reden }))
      };
      const r = await fetch(`/api/inhuur/public/bundle/${token}/respond`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const j = await r.json();
      if (!r.ok) throw j;
      setSuccess(`✅ ${j.verwerkt} ${j.verwerkt===1?'reactie':'reacties'} verstuurd. Bedankt!`);
    } catch (e) { alert(e.error || e.message || 'Fout'); }
    finally { setSubmitting(false); }
  }

  if (loading) return <div style={pageStyle}>Laden...</div>;
  if (error) return <div style={pageStyle}><div style={cardStyle}><h2>⚠️ {error}</h2><p>De link is mogelijk verlopen of ongeldig.</p></div></div>;

  const counts = {
    bevestigen: Object.entries(acties).filter(([id, a]) => a.actie === 'bevestigen' && !data.bestellingen.find(b => b.id === Number(id))?.response_actie).length,
    afwijzen: Object.entries(acties).filter(([id, a]) => a.actie === 'afwijzen' && !data.bestellingen.find(b => b.id === Number(id))?.response_actie).length,
  };
  const totaalActie = counts.bevestigen + counts.afwijzen;

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <div style={{textAlign:'center', marginBottom:24}}>
          <h2 style={{margin:'0 0 4px 0', color:'#1e3a5f'}}>📋 Inhuur-aanvragen</h2>
          <p style={{margin:0, color:'#6b7280'}}>{data.bedrijf_naam} → <strong>{data.resource_naam}</strong></p>
          <p style={{margin:'8px 0 0 0', color:'#374151', fontSize:14}}>{data.bestellingen.length} aanvragen te beoordelen</p>
        </div>

        {success && (
          <div style={{padding:16, background:'#d1fae5', borderRadius:8, marginBottom:16, color:'#065f46', textAlign:'center', fontWeight:600, fontSize:15}}>
            {success}
          </div>
        )}

        <div style={{textAlign:'center', marginBottom:16}}>
          <a href={`/api/inhuur/public/bundle/${token}/pdf`} target="_blank" rel="noopener noreferrer"
             style={{display:'inline-block', padding:'10px 20px', background:'#f3f4f6', color:'#1e3a5f', textDecoration:'none', border:'1px solid #d1d5db', borderRadius:6, fontSize:14, fontWeight:600}}>
            📄 Download als PDF
          </a>
        </div>

        {data.bestellingen.map(b => {
          const a = acties[b.id] || { actie: 'overslaan', reden: '' };
          const al = !!b.response_actie;
          return (
            <div key={b.id} style={{padding:16, marginBottom:12, border:'1px solid #e5e7eb', borderRadius:8, background: al?'#f9fafb':'#fff', opacity: al?0.75:1}}>
              <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:12}}>
                <div style={{flex:1}}>
                  <div style={{fontWeight:600, fontSize:16}}>
                    <strong>{b.aantal}×</strong> {b.resource_naam}
                    {b.specificatie && <span style={{color:'#92400e', marginLeft:8, fontSize:14}}>— {b.specificatie}</span>}
                  </div>
                  <div style={{color:'#6b7280', fontSize:13, marginTop:4}}>
                    📅 {new Date(b.datum_van).toLocaleDateString('nl-NL', {weekday:'long', day:'numeric', month:'long'})}
                    {b.datum_van !== b.datum_tot && ` t/m ${new Date(b.datum_tot).toLocaleDateString('nl-NL', {day:'numeric', month:'short'})}`}
                  </div>
                  {b.wo_locatie && <div style={{color:'#6b7280', fontSize:13, marginTop:2}}>📍 {b.wo_locatie}</div>}
                  {b.opmerking && <div style={{color:'#6b7280', fontSize:12, marginTop:4, fontStyle:'italic'}}>"{b.opmerking}"</div>}
                </div>
                {al && (
                  <span style={{padding:'4px 10px', borderRadius:4, fontSize:12, fontWeight:600,
                    background: b.response_actie === 'bevestigen' ? '#d1fae5' : '#fee2e2',
                    color: b.response_actie === 'bevestigen' ? '#065f46' : '#991b1b'}}>
                    {b.response_actie === 'bevestigen' ? '✅ Bevestigd' : '❌ Afgewezen'}
                  </span>
                )}
              </div>

              {!al && !success && (
                <div style={{marginTop:14, display:'flex', gap:8, flexWrap:'wrap'}}>
                  <label style={{flex:'1 1 30%', padding:'10px', border:`2px solid ${a.actie==='bevestigen'?'#10b981':'#e5e7eb'}`, borderRadius:6, cursor:'pointer', background: a.actie==='bevestigen'?'#d1fae5':'#fff'}}>
                    <input type="radio" checked={a.actie==='bevestigen'} onChange={()=>setActie(b.id,'bevestigen')} style={{marginRight:6}}/>
                    ✅ Bevestigen
                  </label>
                  <label style={{flex:'1 1 30%', padding:'10px', border:`2px solid ${a.actie==='afwijzen'?'#ef4444':'#e5e7eb'}`, borderRadius:6, cursor:'pointer', background: a.actie==='afwijzen'?'#fee2e2':'#fff'}}>
                    <input type="radio" checked={a.actie==='afwijzen'} onChange={()=>setActie(b.id,'afwijzen')} style={{marginRight:6}}/>
                    ❌ Afwijzen
                  </label>
                  <label style={{flex:'1 1 30%', padding:'10px', border:`2px solid ${a.actie==='overslaan'?'#9ca3af':'#e5e7eb'}`, borderRadius:6, cursor:'pointer', background: a.actie==='overslaan'?'#f3f4f6':'#fff', color:'#6b7280'}}>
                    <input type="radio" checked={a.actie==='overslaan'} onChange={()=>setActie(b.id,'overslaan')} style={{marginRight:6}}/>
                    Beslis later
                  </label>
                </div>
              )}

              {!al && !success && a.actie === 'afwijzen' && (
                <textarea value={a.reden} onChange={e=>setReden(b.id, e.target.value)}
                  placeholder="Optioneel: reden voor afwijzing (bv. 'geen mensen meer')"
                  style={{width:'100%', marginTop:8, padding:10, border:'1px solid #d1d5db', borderRadius:4, fontSize:13, fontFamily:'inherit', minHeight:60, boxSizing:'border-box'}}/>
              )}
            </div>
          );
        })}

        {!success && totaalActie > 0 && (
          <div style={{marginTop:20, textAlign:'center'}}>
            <button onClick={submit} disabled={submitting} style={{padding:'14px 32px', background:'#1e3a5f', color:'#fff', border:'none', borderRadius:8, fontSize:16, fontWeight:700, cursor: submitting?'wait':'pointer'}}>
              {submitting ? 'Bezig...' : `📨 Verstuur ${totaalActie} ${totaalActie===1?'reactie':'reacties'}`}
            </button>
            <div style={{marginTop:10, fontSize:13, color:'#6b7280'}}>
              {counts.bevestigen > 0 && `✅ ${counts.bevestigen} bevestigd`}
              {counts.bevestigen > 0 && counts.afwijzen > 0 && ' · '}
              {counts.afwijzen > 0 && `❌ ${counts.afwijzen} afgewezen`}
            </div>
          </div>
        )}

        <hr style={{margin:'30px 0 12px', border:'none', borderTop:'1px solid #e5e7eb'}}/>
        <p style={{textAlign:'center', color:'#9ca3af', fontSize:12, margin:0}}>Verzonden via WOMSYS</p>
      </div>
    </div>
  );
}

const pageStyle = { minHeight:'100vh', padding:20, background:'#f3f4f6', fontFamily:'system-ui, sans-serif' };
const cardStyle = { maxWidth:720, margin:'0 auto', background:'#fff', padding:32, borderRadius:12, boxShadow:'0 4px 20px rgba(0,0,0,0.08)' };
